<cigna-leaf-button
  variant="secondary"
  (click)="labelClick.emit()"
  [neutral]="true"
  data-test-id="filter-label-button"
  [text]="newFilterLabel"
  [svg]="caretDownIcon"
  iconPosition="after"
>
</cigna-leaf-button>
